"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Preview/components/Prerequisites.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_attrs0 = {
        "class": "card my-1"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "card-body"
      },
    marko_attrs3 = {
        "class": "m-0"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("71410f"),
    marko_node0 = marko_createElement("br", null, "5", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  if (Array.isArray(input.list) && input.list.length) {
    out.be("div", marko_attrs0, "0", component);

    out.be("div", marko_attrs1, "1", component);

    out.be("div", marko_attrs2, "2", component);

    out.be("h6", marko_attrs3, "3", component);

    Locale_tag({
        text: "Prerequisites"
      }, out, __component, "4");

    out.ee();

    out.n(marko_node0, component);

    out.be("div", null, "6", component);

    var $for$0 = 0;

    marko_forOf(input.list, function({ label, link }) {
      var $keyScope$0 = "[" + (($for$0++) + "]");

      if (link) {
        out.be("a", {
            type: "button",
            "class": "btn btn-outline-secondary mr-2 mb-2",
            href: link,
            target: "_blank"
          }, "7" + $keyScope$0, component);

        Locale_tag({
            text: label
          }, out, __component, "8" + $keyScope$0);

        out.ee();
      } else {
        Locale_tag({
            text: label,
            class: "btn btn-outline-secondary mr-2 mb-2"
          }, out, __component, "9" + $keyScope$0);
      }
    });

    out.ee();

    out.ee();

    out.ee();

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
